// Final steps section questionnaire constants
export enum FinalStepsQuestionnaireItem {
  FINAL_STEPS_INTERNAL_NOTES = 'final-steps/internal-notes'
}
